import React from "react";
import style from "../../Assets/css/b2b_section_1.module.css";
import img_8153 from "../../Assets/img/Group 8153.png";
import img_8154 from "../../Assets/img/Group 8154.png";
import img_8155 from "../../Assets/img/Group 8155.png";
import img_8145 from "../../Assets/img/Group 8145.png";
import img_8157 from "../../Assets/img/Group 8157.png";
import img_8158 from "../../Assets/img/Group 8158.png";
import img_8156 from "../../Assets/img/Group 8156.png";
import img_gp09 from "../../Assets/img/Mask Group 9.png";
import img_gp11 from "../../Assets/img/Mask Group 11.png";
import img_gp12 from "../../Assets/img/Mask Group 12.png";
import img_2760 from "../../Assets/img/Path 2760.png";
import img_2758 from "../../Assets/img/Path 2758.png";
import img_0020 from "../../Assets/img/Layer_x0020_1.png";
import img_business_standard from "../../Assets/img/business-standard-logo.png";
import img_telengana from "../../Assets/img/telangana-today.png";
import img_logo from "../../Assets/img/logo.png";
import yourStoryLogo from "../../Assets/img/b2b/yourStoryLogo.png";
import businessStandardLogo from "../../Assets/img/b2b/business-standard-logo.png";
import economicsTimesLogo from "../../Assets/img/b2b/economicTimes-logo.png";
import newsMinuteLogo from "../../Assets/img/b2b/the_news_minute.png";
import startUpHydLogo from "../../Assets/img/b2b/startup_hyd.png";

const B2BSection_1 = () => {
	return (
		<>
			<div
				className={`container-fluid ${style.training_description_div} `}
			>
				<div className="row ">
					<div
						className={`col-xl-6 col-lg-8 col-md-10 col-sm-10 col-12 ${style.description_inner_div} `}
					>
						<div className={`d-flex ${style.description_divv} `}>
							<div className={`${style.center_div}`}>
								<img
									src={img_8153}
									alt=""
									className={`img-fluid ${style.icons_imgs}`}
								/>
								<h1 className={`${style.des_no}`}>25,000+</h1>
								<h6 className={`${style.des_text}`}>
									Students Trained
								</h6>
							</div>
							<div className={`${style.section_vl}`}></div>
							<div className={`${style.center_div}`}>
								<img
									src={img_8154}
									alt=""
									className={`img-fluid ${style.icons_imgs}`}
								/>
								<h1 className={`${style.des_no}`}>94%</h1>
								<h6 className={`${style.des_text}`}>
									Placements Achieved
								</h6>
							</div>
							<div className={`${style.section_vl}`}></div>
							<div className={`${style.center_div}`}>
								<img
									src={img_8155}
									alt=""
									className={`img-fluid ${style.icons_imgs}`}
								/>
								<h1 className={`${style.des_no}`}>140+</h1>
								<h6 className={`${style.des_text}`}>
									Colleges Collaborated
								</h6>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div className={`container-fluid ${style.awards_outer_div}`}>
				<div className="row">
					<div className="col-xl-3 col-lg-4 col-md-5 col-sm-6 col-8">
						<h1 className={`${style.awardsheading}`}>
							Awards & Recognitions
						</h1>
					</div>
				</div>
				<br />
				<div className="row">
					<div className="col-xl-5 col-lg-6 col-md-6 col-sm-6 col-12">
						<div className="d-flex justify-content-around">
							<div className={`${style.company_logo_div}`}>
								<img
									src={img_8145}
									alt=""
									className={`${style.company_logo_img}`}
								/>
							</div>
							<div className={`${style.awards_text_div}`}>
								<p>
									Lorem Ipsum is simply dummy text of the
									printing and typesetting industry. Lorem
									Ipsum has been the industry's standard dummy
									text ever since the 1500s, when an unknown
									printer took a galley of type and scrambled
									it to make a Lorem Ipsum is simply{" "}
								</p>
							</div>
						</div>
					</div>
					<div className="col-xl-5 col-lg-6 col-md-6 col-sm-6 col-12">
						<div className="d-flex justify-content-around">
							<div className={`${style.company_logo_div}`}>
								<img
									src={img_8156}
									alt=""
									className={`${style.company_logo_img}`}
								/>
							</div>
							<div className={`${style.awards_text_div}`}>
								<p>
									Lorem Ipsum is simply dummy text of the
									printing and typesetting industry. Lorem
									Ipsum has been the industry's standard dummy
									text ever since the 1500s, when an unknown
									printer took a galley of type and scrambled
									it to make a Lorem Ipsum is simply{" "}
								</p>
							</div>
						</div>
					</div>
				</div>

				<div className="row">
					<div className="col-xl-5 col-lg-6 col-md-6 col-sm-6 col-12">
						<div className="d-flex justify-content-around">
							<div className={`${style.company_logo_div}`}>
								<img
									src={img_8158}
									alt=""
									className={`${style.company_logo_img}`}
								/>
							</div>
							<div className={`${style.awards_text_div}`}>
								<p>
									Lorem Ipsum is simply dummy text of the
									printing and typesetting industry. Lorem
									Ipsum has been the industry's standard dummy
									text ever since the 1500s, when an unknown
									printer took a galley of type and scrambled
									it to make a Lorem Ipsum is simply{" "}
								</p>
							</div>
						</div>
					</div>
					<div className="col-xl-5 col-lg-6 col-md-6 col-sm-6 col-12">
						<div className="d-flex justify-content-around">
							<div className={`${style.company_logo_div}`}>
								<img
									src={img_8157}
									alt=""
									className={`${style.company_logo_img}`}
								/>
							</div>
							<div className={`${style.awards_text_div}`}>
								<p>
									Lorem Ipsum is simply dummy text of the
									printing and typesetting industry. Lorem
									Ipsum has been the industry's standard dummy
									text ever since the 1500s, when an unknown
									printer took a galley of type and scrambled
									it to make a Lorem Ipsum is simply{" "}
								</p>
							</div>
						</div>
					</div>
					<div
						className={`col-xl-2 col-lg-2 ${style.side_image_div}`}
					>
						<img
							src={img_gp11}
							alt=""
							className={`${style.side_image} img-fluid`}
						/>
					</div>
				</div>
			</div>

			<div className={`container-fluid ${style.news_articles}`}>
				<div className="row">
					<div
						className={`col-xl-5 col-lg-5 col-md-5 col-sm-5 col-12 ${style.stories_press}`}
					>
						<img src={img_2760} alt="" className={style.comma} />
						<div className={`${style.stories_press_innerdiv}`}>
							<h1
								className={`${style.stories_from_heading} ${style.head_top}`}
							>
								Stories from{" "}
							</h1>
							<h1 className={`${style.stories_from_heading}`}>
								Press & Media
							</h1>
							<p className="text-center">
								click on the cards to get redirected
							</p>
						</div>
					</div>
					<div
						className={`col-xl-7 col-lg-7 col-md-7 col-sm-7 col-12 ${style.business_standard_outer_div}`}
						style={{ marginBottom: "0" }}
					>
						<a
							className={style.anchorMedia}
							href="https://www.business-standard.com/article/pti-stories/t-hub-announces-second-batch-of-startups-for-its-incubation-119052800760_1.html"
							target="_blank"
							rel="noreferrer"
						>
							<div
								className={`col-xl-9 col-lg-9 col-md-10 col-sm-10 col-12 ${style.business_standard}`}
								style={{ marginTop: "8%", marginBottom: "0" }}
							>
								<img
									src={img_business_standard}
									alt=""
									className="img-fluid"
								/>
								<br />
								<img src={img_2758} alt="" />
								<p style={{ fontSize: "14px" }}>
									{'T-Hub,an initiative by the Telangana government for startups, Tuesday announced selection of 45 startups for the second edition of its incubation programme, Lab32. The new batch of startups will receive a progressive set of advantages that will help entrepreneurs grow faster, a statement from T-Hub said. Lab32 is designed to ensure the strategic growth of startups in India. The programme aims to support the government\'s "Startup India Initiative" by directing entrepreneurship, innovation and addressing the challenges faced by startups, Lab32 said adding it is a comprehensive incubation programme, which is tailor-made for early-stage tech product startups.'.substring(
										0,
										295
									) + "...."}
								</p>
							</div>
						</a>
					</div>
				</div>

				<div className={`row ${style.news_row_2}`}>
					<div
						className={`col-xl-2 col-lg-2 ${style.left_side_image_div}`}
					>
						<img
							src={img_gp12}
							alt=""
							className={`img-fluid ${style.left_side_image}`}
						/>
					</div>
					<div className="col-xl-2 col-lg-6 col-md-6 col-6">
						<a
							className={style.anchorMedia}
							style={{ textDecoration: "none" }}
							href="https://www.financialexpress.com/industry/sme/startup-incubator-t-hub-picks-second-batch-loaded-with-b2b-businesses-82-claims-revenue-as-well/1591591/"
							target="_blank"
							rel="noreferrer"
						>
							<div className={`${style.financial_express}`}>
								<img
									src={img_0020}
									alt=""
									className="img-fluid"
								/>
								<br />
								<img src={img_2758} alt="" />
								<p style={{ fontSize: "14px" }}>
									{/* {("India’s third-largest startup incubator T-Hub has picked 45
                  startups for the second batch of its incubation programme
                  Lab32 that focuses on early-stage technology startups. The
                  six-month incubation begins in May while the applications for
                  the next batch are likely planned for the second half of 2019.").substring(0,244)} */}
									{"India’s third-largest startup incubator T-Hub has picked 45 startups for the second batch of its incubation programme Lab32 that focuses on early-stage technology startups. The six-month incubation begins in May while the applications for the next batch are likely planned for the second half of 2019.".substring(
										0,
										265
									) + "...."}
									{/* India’s third-largest startup incubator T-Hub has picked 45
                  startups for the second batch of its incubation programme
                  Lab32 that focuses on early-stage technology startups. The
                  six-month incubation begins in May while the applications for
                  the next batch are likely planned for the second half of 2019. */}
								</p>
							</div>
						</a>
					</div>
					<div className="col-xl-2 col-lg-6 col-md-6 col-6">
						<a
							className={style.anchorMedia}
							href="https://economictimes.indiatimes.com/small-biz/startups/newsbuzz/t-hub-announces-its-second-batch-of-innovative-startups-for-its-incubation-programme-lab32/articleshow/69564501.cms"
							target="_blank"
							rel="noreferrer"
						>
							<div className={`${style.financial_express}`}>
								<img
									src={economicsTimesLogo}
									alt=""
									className="img-fluid"
								/>
								<br />
								<img src={img_2758} alt="" />
								<p style={{ fontSize: "14px" }}>
									{"T-Hub has announced the selection of 45 startups for the second edition of its incubation programme, Lab32. It is a comprehensive incubation programme, which is tailor-made for early-stage tech product startups. The new batch of startups will recieve progressive set of advantages that will help entrepreneurs grow faster. The programme aims to support the government fs eStartup India Initiative by directing entrepreneurship, innovation and addressing the challenges faced by startups. The startups were be shortlisted after screening more than 500 applications from across India. These startups offer technology innovations for developing solutions for Digital India in industries such as healthtech,fintech,smart mobility,sustainability,social impact,smart cities and ed-tech,amongst others.".substring(
										0,
										242
									) + "...."}
								</p>
							</div>
						</a>
					</div>
					<div
						className={`col-xl-6 col-lg-5 col-md-6 ${style.news_row_col_2}`}
					>
						<div className="row">
							<div
								className={`col-xl-5 ${style.deccan_chronicle}`}
							>
								<a
									className={style.anchorMedia}
									href="https://yourstory.com/2019/05/startup-incubator-t-hub-telangana-lab32/amp"
									target="_blank"
									rel="noreferrer"
								>
									{" "}
									<img
										style={{
											height: "20px",
											width: "120px",
										}}
										src={yourStoryLogo}
										alt=""
										className="img-fluid"
									/>
									<br />
									<img src={img_2758} alt="" />
									<p style={{ fontSize: "14px" }}>
										{"Lab32 is a programme with the unique mix of tech startups, which is the need of the hour for growth stage startups. It’s an opportunity for investors to support these handpicked ones and contribute to their growth story.T-Hub also provides thought leadership for Telangana and other State and Central government organisations to build innovation ecosystems.".substring(
											0,
											320
										) + "...."}
									</p>
								</a>
							</div>
							<div
								className={`col-xl-5 ${style.times_of_india_2}`}
							>
								<a
									className={style.anchorMedia}
									href="https://www.thenewsminute.com/article/t-hub-picks-45-startups-second-cohort-its-incubation-program-lab32-102557"
									target="_blank"
									rel="noreferrer"
								>
									<img
										// style={{
										//   height: "100px",
										//   position: "relative",
										//   left: "18%",
										//   bottom: "4%",
										// }}
										src={newsMinuteLogo}
										alt=""
										className="img-fluid"
									/>
									<br />
									<img src={img_2758} alt="" />
									<p style={{ fontSize: "14px" }}>
										{"Avanish Mundhra founder of Cantilever Labs said, “On the product front, our expectation from Lab32 program is to fine-tune our product for stability, affordability and scalability. On the business front, we expect Lab32 to connect us to a host of colleges, corporates and government bodies. Lab32 is an excellent platform for passionate and motivated first-generation entrepreneurs, guided by a team of champion mentors from whom I expect to learn, un-learn, evolve, network and grow our business.”".substring(
											0,
											296
										) + "..."}
									</p>
								</a>
							</div>
						</div>
						<div className="row">
							<div
								className={`col-xl-10 col-lg-12 col-md-11 col-12 ${style.times_of_india}`}
							>
								<a
									className={style.anchorMedia}
									href="http://startuphyderabad.com/t-hub-announces-its-second-batch-of-innovative-startups-for-its-incubation-programme-lab32/"
									target="_blank"
									rel="noreferrer"
								>
									<img
										style={{
											height: "40px",
											left: "12px",
											position: "relative",
										}}
										src={startUpHydLogo}
										alt=""
										className="img-fluid"
									/>
									<br />
									<img src={img_2758} alt="" />
									<p style={{ fontSize: "14px" }}>
										{"T-Hub which pioneers India’s leading innovation ecosystem that powers next-generation products and new business models, today announced the selection of 45 startups for the second edition of its incubation programme, Lab32. It is a comprehensive incubation programme, which is tailor-made for early-stage tech product startups. The new batch of startups will receive a progressive set of advantages that will help entrepreneurs grow faster. Lab32 is designed to ensure the strategic growth of startups in India. The programme aims to support the government’s ‘Startup India Initiative’ by directing entrepreneurship, innovation and addressing the challenges faced by startups.".substring(
											0,
											259
										) + "...."}
									</p>
								</a>
							</div>
						</div>
					</div>
				</div>
			</div>

			<br />
			<br />
		</>
	);
};

export default B2BSection_1;
